import { ProgramWorkbookDownload } from "./ProgramWorkbookDownload";
import { WorkbookData } from "@platform/types/dashboard.types";
import { usePlatformStore } from "@platform/store";

export type Props = {
  /** Callback when a download button is clicked */
  onDownload?: () => void;
};

export function ProgramWorkbookDownloadContainer({ onDownload }: Props) {
  const data = {
    file: {
      name: "Pollinator Workbook: Fall 2025 Cycle",
      type: "PDF",
      size: "",
      downloadUrl:
        "https://pollinator-production.s3.us-east-1.amazonaws.com/production/assets/materials/PollinatorWorkbookFall2025Cycle.pdf",
    },
    caption: {
      text: "Pollinator Workbook: Fall 2025 Cycle",
    },
  } as WorkbookData;

  const isWorkbookDownloadDisabled = usePlatformStore(
    (s) => s.featureFlags.isWorkbookDownloadDisabled
  );

  if (isWorkbookDownloadDisabled) {
    return null;
  }

  return <ProgramWorkbookDownload data={data} onDownload={onDownload} />;
}

export default ProgramWorkbookDownloadContainer;

